import { useState } from "react";
import { toast } from "sonner";
import { Loader2, UserPlus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api } from "@/lib/api";

const errMsg = (e) => {
  const d = e.response?.data?.detail;
  return Array.isArray(d) ? d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join(", ") : d || "Failed";
};

export const AddTeacherDialog = ({ auth, onDone }) => {
  const empty = { name: "", email: "", password: "", school_name: "" };
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(empty);
  const [loading, setLoading] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/teachers", f, auth);
      toast.success(`Trainer login created for ${f.email}`);
      setF(empty); setOpen(false); onDone();
    } catch (e2) { toast.error(errMsg(e2)); } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="rounded-full bg-white border border-[#00E5FF]/40 hover:bg-[#FF3B3B] hover:border-[#FF3B3B] text-[#0A192F] hover:text-white" data-testid="add-teacher-btn"><UserPlus className="w-4 h-4 mr-1" />Add trainer</Button>
      </DialogTrigger>
      <DialogContent className="bg-white" aria-describedby={undefined} data-testid="add-teacher-dialog">
        <DialogHeader><DialogTitle>New trainer login</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <Input required placeholder="Full name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="teacher-name-input" />
          <Input required type="email" placeholder="Email (login)" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="teacher-email-input" />
          <Input required minLength={8} placeholder="Password (min 8 characters)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="teacher-password-input" />
          <Input required placeholder="School name (must match enrollment school)" value={f.school_name} onChange={(e) => setF({ ...f, school_name: e.target.value })} data-testid="teacher-school-input" />
          <p className="text-xs text-slate-500">The trainer sees paid students whose school name matches exactly (not case-sensitive). Share the email and password with them; they sign in at /teacher/login.</p>
          <Button type="submit" disabled={loading} className="w-full rs-cta rounded-full" data-testid="teacher-create-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create login"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export const DeleteTeacherButton = ({ teacher, auth, onDone }) => {
  const del = async () => {
    if (!window.confirm(`Remove trainer login for ${teacher.email}?`)) return;
    try { await api.delete(`/admin/teachers/${teacher.id}`, auth); toast.success("Trainer removed"); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return <Button size="sm" variant="outline" className="h-7 text-red-600" onClick={del} data-testid={`delete-teacher-${teacher.id}`}><Trash2 className="w-3.5 h-3.5 mr-1" />Remove</Button>;
};
